// PusherProvider.js
import { useEffect, useState } from 'react';
import Pusher from 'pusher-js';
import { getToken } from '../services/DaoService';
import PropTypes from 'prop-types';
import { useUserContext } from '../contexts/UserContext';
import PusherContext from '../contexts/PusherContext';

export const PusherProvider = ({ children }) => {
    const [pusher, setPusher] = useState(null);
    const { currentUser } = useUserContext(); // Utilisation du contexte utilisateur
    const [userPrivateChannelName, setUserPrivateChannelName] = useState(null);

    useEffect(() => {
        if (currentUser) {
            const pusherInstance = new Pusher(import.meta.env.VITE_APP_PUSHER_APP_KEY, {
                cluster: import.meta.env.VITE_APP_PUSHER_APP_CLUSTER,
                forceTLS: true,
                authEndpoint: `${import.meta.env.VITE_APP_API_URL}/broadcasting/auth`,
                auth: {
                    headers: {
                        Authorization: `Bearer ${getToken()}`,
                        Accept: 'application/json',
                    },
                },
                channelAuthorization: {
                    endpoint: `${import.meta.env.VITE_APP_API_URL}/broadcasting/auth/channel`,
                    headers: {
                        Authorization: `Bearer ${getToken()}`,
                        Accept: 'application/json',
                    },
                    params: {
                        token: getToken(),
                    },
                },
            });

            // Gestion des erreurs de connexion Pusher
            pusherInstance.connection.bind('error', (err) => {
                console.error('Pusher connection error:', err);
            });

            // Suivi des changements d'état de la connexion Pusher
           /* pusherInstance.connection.bind('state_change', (states) => {
                console.log('Pusher connection state change:', states);
            }); */

            // Confirmation de la connexion réussie
           /* pusherInstance.connection.bind('connected', () => {
                console.log('Pusher connection success');
            }); */

            setPusher(pusherInstance);

            setUserPrivateChannelName(`private-App.Models.User.${currentUser.id}`);

            return () => {
                pusherInstance.disconnect(); // Déconnexion propre lors du démontage
            };
        }
    }, [currentUser]);

    return (
        <PusherContext.Provider value={{ pusher, userPrivateChannelName }}>
            {children}
        </PusherContext.Provider>
    );
};

PusherProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
